// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"A_TheComp__I38V6"};